// Pathway-specific concern chips shown in the intake form's "About what's
// happening" section. Keep these short, plain-English; the chip values
// (the `id`) are stored on the prospect and are used for clustering /
// dashboards. Adding a chip here is safe — it's a freeform list on the
// backend (PatientProspectInfo.intakeAnswers).

export const CONCERNS_BY_PATHWAY = {
  PSYCHIATRY: [
    { id: 'anxiety', label: 'Anxiety' },
    { id: 'low_mood', label: 'Low mood / depression' },
    { id: 'sleep', label: 'Sleep' },
    { id: 'focus', label: 'Focus / attention' },
    { id: 'addiction', label: 'Addiction / substance use' },
    { id: 'other', label: 'Something else' },
  ],
  THERAPY: [
    { id: 'anxiety', label: 'Anxiety' },
    { id: 'low_mood', label: 'Low mood' },
    { id: 'sleep', label: 'Sleep' },
    { id: 'relationships', label: 'Relationships' },
    { id: 'work_stress', label: 'Work / stress' },
    { id: 'grief', label: 'Grief / loss' },
    { id: 'other', label: 'Something else' },
  ],
  BIOLOGICAL: [
    { id: 'thyroid', label: 'Thyroid' },
    { id: 'diabetes', label: 'Diabetes' },
    { id: 'pcos', label: 'PCOS / period concerns' },
    { id: 'weight', label: 'Weight' },
    { id: 'autoimmune', label: 'Autoimmune flare' },
    { id: 'joint_skin', label: 'Joint / skin' },
    { id: 'unexplained', label: 'Unexplained inflammation' },
    { id: 'other', label: 'Something else' },
  ],
  CHILD: [
    { id: 'growth', label: 'Growth' },
    { id: 'behavior', label: 'Behaviour' },
    { id: 'learning', label: 'Learning' },
    { id: 'sleep', label: 'Sleep' },
    { id: 'nutrition', label: 'Nutrition' },
    { id: 'other', label: 'Something else' },
  ],
  ASSESSMENT: [
    { id: 'not_sure', label: "I'm not sure yet" },
    { id: 'general', label: 'General check-in' },
    { id: 'other', label: 'Something else' },
  ],
}

export function chipsForPathway(pathway) {
  if (!pathway) return CONCERNS_BY_PATHWAY.ASSESSMENT
  return CONCERNS_BY_PATHWAY[pathway] || CONCERNS_BY_PATHWAY.ASSESSMENT
}

export const DURATION_OPTIONS = [
  { id: 'DAYS', label: 'A few days' },
  { id: 'WEEKS', label: 'A few weeks' },
  { id: 'MONTHS', label: 'Months' },
  { id: 'LONG_TERM', label: 'Long term — over a year' },
]

export const PRIOR_SUPPORT_OPTIONS = [
  { id: 'NONE', label: 'Nothing yet' },
  { id: 'THERAPY', label: 'Therapy' },
  { id: 'MEDICATION', label: 'Medication' },
  { id: 'BOTH', label: 'Both therapy and medication' },
]

export const SUBJECT_TYPE_OPTIONS = [
  { id: 'SELF', label: 'For me' },
  { id: 'CHILD', label: 'For my child' },
  { id: 'DEPENDENT', label: 'For someone I care for' },
]
